import React, { useMemo, useState } from 'react';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import Panel from '../components/Panel';
import { IconCube } from '../components/icons';

const BASELINE = api.simulate({ newLine: false, frequency: 10, closeAxis: false });

function Metric({ label, value, unit, base, betterWhenLower }) {
  const delta = value - base;
  const improved = betterWhenLower ? delta < 0 : delta > 0;
  const neutral = delta === 0;
  return (
    <div className="sim-metric">
      <div className="v">{value}<span style={{ fontSize: 15, color: 'var(--faint)' }}>{unit}</span></div>
      <div className="l">{label}</div>
      {!neutral && (
        <div className={`d ${improved ? 'delta-good' : 'delta-bad'}`}>
          {delta > 0 ? '+' : ''}{delta}{unit} {improved ? '▼ mieux' : '▲'}
        </div>
      )}
    </div>
  );
}

export default function DigitalTwin() {
  const [newLine, setNewLine] = useState(true);
  const [frequency, setFrequency] = useState(8);
  const [closeAxis, setCloseAxis] = useState(false);

  const out = useMemo(() => api.simulate({ newLine, frequency, closeAxis }), [newLine, frequency, closeAxis]);
  const { live } = useApi(() => api.health());

  return (
    <>
      <Topbar title="Jumeau numérique — simulation" subtitle="« Et si ? » : mesurer l'impact d'une décision sur le réseau" live={live} />
      <div className="content">
        <div className="grid grid--2-1">
          <Panel icon={IconCube} title="Résultat de la simulation" sub="Impact prédit vs situation actuelle" delay={80}>
            <div className="sim-out">
              <Metric label="Temps de trajet moyen" value={out.temps_trajet_min} unit=" min" base={BASELINE.temps_trajet_min} betterWhenLower />
              <Metric label="Couverture réseau" value={out.couverture_pct} unit=" %" base={BASELINE.couverture_pct} betterWhenLower={false} />
              <Metric label="Indice de congestion" value={out.congestion_index} unit="" base={BASELINE.congestion_index} betterWhenLower />
            </div>
            <p className="panel__sub" style={{ marginTop: 16 }}>
              Référence actuelle : {BASELINE.temps_trajet_min} min · {BASELINE.couverture_pct}% couverture · congestion {BASELINE.congestion_index}.
            </p>
          </Panel>

          <Panel icon={IconCube} title="Scénario" sub="Ajuste les leviers" delay={140}>
            <div className="control">
              <div className="control__label">
                <span>Ajouter une nouvelle ligne</span>
                <span className={`switch${newLine ? ' on' : ''}`} onClick={() => setNewLine((v) => !v)} role="switch" aria-checked={newLine} />
              </div>
              <div className="panel__sub">Guédiawaye → Plateau (désert desservi)</div>
            </div>
            <div className="control">
              <div className="control__label"><span>Fréquence des bus</span><span className="mono">{frequency} min</span></div>
              <input className="range" type="range" min="4" max="20" value={frequency} onChange={(e) => setFrequency(Number(e.target.value))} />
            </div>
            <div className="control">
              <div className="control__label">
                <span>Fermer un axe (travaux VDN)</span>
                <span className={`switch${closeAxis ? ' on' : ''}`} onClick={() => setCloseAxis((v) => !v)} role="switch" aria-checked={closeAxis} />
              </div>
              <div className="panel__sub">Simule une perturbation majeure</div>
            </div>
          </Panel>
        </div>
      </div>
    </>
  );
}
